import { Link } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import LoginForm from "../features/Login/components/LoginForm";


const LoginPage = () => {
    return (
        <div className="bg-black flex flex-col items-center justify-center h-screen w-full">
            <LoginForm />
        </div>
    );
};

export default LoginPage;
